var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetNavCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5899 67.982C65.2314 67.982 68.9942 64.2192 68.9942 59.5777C68.9942 54.9361 65.2314 51.1733 60.5899 51.1733C55.9483 51.1733 52.1855 54.9361 52.1855 59.5777C52.1855 64.2192 55.9483 67.982 60.5899 67.982Z",
    stroke: "#630163",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8688 64.7752L42.1027 76.5412M55.5496 53.0091L40.4219 37.8813",
    stroke: "#630163",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4 79.9018C80.185 79.9018 82.4426 77.6442 82.4426 74.8592C82.4426 72.0743 80.185 69.8167 77.4 69.8167C74.6151 69.8167 72.3574 72.0743 72.3574 74.8592C72.3574 77.6442 74.6151 79.9018 77.4 79.9018Z",
    stroke: "#630163",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.485 63.0937C90.2699 63.0937 92.5276 60.8361 92.5276 58.0511C92.5276 55.2662 90.2699 53.0085 87.485 53.0085C84.7 53.0085 82.4424 55.2662 82.4424 58.0511C82.4424 60.8361 84.7 63.0937 87.485 63.0937Z",
    stroke: "#630163",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4412 58.0496H68.9943M67.3135 64.773L74.0369 71.4965",
    stroke: "#630163",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2139 45.596C86.8555 45.596 90.6182 41.8332 90.6182 37.1917C90.6182 32.5501 86.8555 28.7874 82.2139 28.7874C77.5723 28.7874 73.8096 32.5501 73.8096 37.1917C73.8096 41.8332 77.5723 45.596 82.2139 45.596Z",
    stroke: "#630163",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2522 43.1506L66.167 53.2358",
    stroke: "#630163",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0602 39.5615C39.8451 39.5615 42.1028 37.3039 42.1028 34.5189C42.1028 31.734 39.8451 29.4763 37.0602 29.4763C34.2752 29.4763 32.0176 31.734 32.0176 34.5189C32.0176 37.3039 34.2752 39.5615 37.0602 39.5615Z",
    stroke: "#630163",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1494 89.9873C39.791 89.9873 43.5537 86.2246 43.5537 81.583C43.5537 76.9415 39.791 73.1787 35.1494 73.1787C30.5079 73.1787 26.7451 76.9415 26.7451 81.583C26.7451 86.2246 30.5079 89.9873 35.1494 89.9873Z",
    stroke: "#630163",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetNavCardIcon);
export default __webpack_public_path__ + "static/media/AssetNavCardIcon.f1d821ffd3255bda9d8665ead5771aed.svg";
export { ForwardRef as ReactComponent };